import { apiClientV1 } from './apiClient';

export default {
  generateGif: (videoId, params) => apiClientV1.post(`/video/${videoId}/generate-gif`, { ...params }),
  getGifConvertJob: (videoId) => apiClientV1.get(`/video/${videoId}/convert-job`),
  deleteGif: (videoId) => apiClientV1.delete(`/video/${videoId}/convert-job`)
};
